var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BuildStorageObjectFromCustom, parseWindowLocalStorageToMap } from './utils';
export class StorageController {
    constructor(instance, con) {
        this.persistence_keys = [];
        this.enalbed = false;
        this.config = { customEnabled: false };
        this._prefixKey = '_simple_';
        this.SimpleInstance = instance;
        // Set the custom prefix
        if (con === null || con === void 0 ? void 0 : con.prefix)
            this._prefixKey = con.prefix;
        // If the get and set methods are supplied we are expecting we are not using LocalStorage anymore
        if (con === null || con === void 0 ? void 0 : con.custom) {
            let b = {
                customEnabled: true,
                custom: con.custom,
            };
            Object.assign(this.config, b);
        }
    }
    // Sync up the core from the storage when the app is starting up
    initializeStorageWithCore() {
        return __awaiter(this, void 0, void 0, function* () {
            const _storageObject = (this.config.customEnabled
                ? yield BuildStorageObjectFromCustom(this.SimpleInstance._data, this)
                : parseWindowLocalStorageToMap(this.SimpleInstance._data));
            // go trough the core
            for (let item of Object.entries(this.SimpleInstance._data)) {
                const coreKeyName = item[0];
                const storageKeyValue = _storageObject[coreKeyName];
                // Check if we a re persisting the key name
                if (this.persistence_keys.includes(coreKeyName)) {
                    // Tell the state that this is a persited value
                    this.SimpleInstance._data[coreKeyName]._peristed = true;
                    // we need to update the key from the core with the storage object
                    // Check if the storage object key is null
                    if (storageKeyValue === undefined || storageKeyValue === null) {
                        this.set(coreKeyName, item[1]._value);
                    }
                    else {
                        this.SimpleInstance._data[coreKeyName].set(storageKeyValue);
                    }
                }
            }
        });
    }
    set(key, value) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.customEnabled) {
                yield this.config.custom.set(this._prefixKey + key, JSON.stringify(value));
            }
            else {
                if (window === null || window === void 0 ? void 0 : window.localStorage) {
                    if (value === undefined)
                        value = null;
                    localStorage.setItem(this._prefixKey + key, JSON.stringify(value));
                }
                else {
                    throw 'Default storage instance not found';
                }
            }
        });
    }
    get(key) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.customEnabled) {
                return JSON.parse(yield this.config.custom.get(this._prefixKey + key));
            }
            else {
                if (window === null || window === void 0 ? void 0 : window.localStorage) {
                    return JSON.parse(localStorage.getItem(this._prefixKey + key));
                }
                else {
                    throw 'Default storage instance not found';
                }
            }
        });
    }
}
//# sourceMappingURL=storage.js.map